import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="bg-brand-paper min-h-screen">
      <Header />
      <main className="pt-[84px]">
        <div className="bg-brand-navy py-16">
          <div className="max-w-4xl mx-auto px-5 lg:px-8">
            <h1 className="font-display text-4xl md:text-5xl text-white tracking-tight">Privacy Policy</h1>
            <p className="mt-4 text-slate-300 text-base md:text-lg">BMS Health Care Services Ltd.</p>
          </div>
        </div>
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-16">
          <Reveal>
            <div className="rounded-2xl border border-slate-200 bg-white p-8 md:p-12 space-y-8 text-sm md:text-base leading-relaxed text-slate-600">
              <section>
                <h2 className="font-display text-2xl text-brand-navy mb-3">Our Commitment to Privacy</h2>
                <p>BMS Health Care Services Ltd. is committed to protecting the privacy and confidentiality of personal information entrusted to us by patients, families, and healthcare professionals. Personal information is collected, used, and disclosed in accordance with applicable privacy legislation in British Columbia and Canada.</p>
              </section>
              <section>
                <h2 className="font-display text-2xl text-brand-navy mb-3">Information We Collect</h2>
                <p>When you submit a Patient Referral Form or contact us, we may collect personal information such as name, date of birth, contact details, home address, emergency contact information, referring healthcare professional details, and information relevant to care needs and support requirements.</p>
              </section>
              <section>
                <h2 className="font-display text-2xl text-brand-navy mb-3">How We Use Information</h2>
                <p>Personal information is used only for the purpose of discussing, assessing, and arranging appropriate home care and support services, communicating with patients and their authorized representatives, and coordinating care with referring healthcare professionals where consent has been provided.</p>
              </section>
              <section>
                <h2 className="font-display text-2xl text-brand-navy mb-3">Confidentiality & Security</h2>
                <p>All personal information is handled confidentially. We apply appropriate administrative and technical safeguards to protect personal information against unauthorized access, disclosure, or misuse. Access to referral information is restricted to authorized personnel only.</p>
              </section>
              <section>
                <h2 className="font-display text-2xl text-brand-navy mb-3">Your Consent</h2>
                <p>By submitting the Patient Referral Form, you confirm that you are the patient or the patient's authorized representative and consent to the information being shared with BMS Health Care Services Ltd. for the purposes described above. You may withdraw consent or request access to your information at any time by contacting us.</p>
              </section>
              <section>
                <h2 className="font-display text-2xl text-brand-navy mb-3">Contact Us</h2>
                <p>If you have questions about this Privacy Policy or how your information is handled, please contact us at +1 (778) 837-2786 or info@bmshealthcareservices.com.</p>
              </section>
            </div>
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
}
